<div class="campaign-generate">
  <section class="campaign-card">
    <div class="campaign-card__header">
      <div>
        <h2>Detalhes da Campanha</h2>
      </div>
      <p-button
        label="Editar"
        icon="pi pi-pencil"
        severity="secondary"
        [outlined]="true"
        size="small"
        type="button"
        (onClick)="navigateToEdit()"
      ></p-button>
    </div>

    <div class="campaign-details" *ngIf="campaign">
      <div *ngIf="campaign.coverUrl" class="campaign-cover-section">
        <div class="campaign-cover-preview">
          <img [src]="campaign.coverUrl" alt="Capa da campanha" />
        </div>
      </div>
      <div>
        <span class="campaign-details__label">Nome da campanha</span>
        <span class="campaign-details__value">{{ campaign.name }}</span>
      </div>
      <div>
        <span class="campaign-details__label">Descrição Interna</span>
        <span class="campaign-details__value">{{ campaign.description || '-' }}</span>
      </div>
      <div>
        <span class="campaign-details__label">Validade</span>
        <span class="campaign-details__value">
          {{ campaign.startDate | date: 'dd/MM/yyyy' }} -
          {{ campaign.endDate | date: 'dd/MM/yyyy' }}
        </span>
      </div>
      <div>
        <span class="campaign-details__label">Status</span>
        <span class="status" [ngClass]="statusBadgeClass">{{ statusLabel }}</span>
      </div>
    </div>

    <div class="campaign-card__header">
      <div>
        <h2>Brindes da campanha</h2>
      </div>
    </div>

    <div class="gift-list" *ngIf="gifts.length">
      <div class="gift-card" *ngFor="let gift of gifts; trackBy: trackGift">
        <div class="gift-card__info">
          <div class="gift-card__label">Produto</div>
          <div class="gift-card__title">
            {{
              gift.validation?.productVariantName ||
                gift.productVariantId ||
                gift.internalEan
            }}
          </div>
          <div class="gift-card__subtitle">
            EAN: {{ gift.internalEan || gift.ean }}
          </div>
        </div>
        <div class="gift-card__meta">
          <div>
            <div class="gift-card__label">Estoque</div>
            <p-progressSpinner
              *ngIf="gift['_validating']"
              [style]="spinnerStyle"
              strokeWidth="6"
            ></p-progressSpinner>
            <div
              *ngIf="!gift['_validating']"
              class="gift-card__value"
              [ngClass]="{
                'gift-card__value--danger':
                  (gift.validation?.inStockReserveMarketing || 0) <= 0,
                'gift-card__value--warning':
                  (gift.validation?.inStockReserveMarketing || 0) > 0 &&
                  (gift.validation?.inStockReserveMarketing || 0) <
                    filteredCustomers().length * (gift.quantity || 1),
                'gift-card__value--success':
                  (gift.validation?.inStockReserveMarketing || 0) > 0 &&
                  (gift.validation?.inStockReserveMarketing || 0) >=
                  filteredCustomers().length * (gift.quantity || 1)
              }"
            >
              {{ gift.validation?.inStockReserveMarketing || 0 }}
            </div>
          </div>
          <div>
            <div class="gift-card__label">Qtd</div>
            <div class="gift-card__value">{{ gift.quantity || 0 }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="campaign-card__header">
      <div>
        <h2>Clientes Elegíveis</h2>
      </div>
    </div>

    <app-table
      [lazy]="false"
      [cols]="columns"
      [elements]="filteredCustomers()"
      [captionTemplate]="searchTemplate"
      [addButton]="false"
    ></app-table>

    <ng-template #searchTemplate>
      <form class="form-b4a campaign-table-filters" [formGroup]="filterForm">
        <span class="p-float-label">
          <input
            pInputText
            id="customerSearch"
            formControlName="search"
            (input)="updateSearch()"
          />
          <label for="customerSearch">E-mail ou ID do Cliente</label>
        </span>
        <p-button
          label="Recarregar"
          icon="pi pi-refresh"
          type="button"
          [text]="true"
          (onClick)="loadEligibleCustomers()"
        />
      </form>
    </ng-template>

    <div class="campaign-card__header">
      <div>
        <h2>Inteligência de Envio</h2>
      </div>
    </div>

    <form [formGroup]="filterForm" class="form-b4a">
      <span class="p-float-label">
        <p-dropdown
          inputId="strategy"
          [options]="strategyOptions"
          formControlName="strategy"
          optionLabel="label"
          optionValue="value"
        ></p-dropdown>
        <label for="strategy">Estratégia de Alocação</label>
      </span>
    </form>

    <div class="stock-validation-errors" *ngIf="stockValidationErrors.length">
      <div class="stock-validation-errors__header">
        <i class="pi pi-exclamation-triangle"></i>
        <strong>Erro de Validação de Estoque</strong>
      </div>
      <ul class="stock-validation-errors__list">
        <li *ngFor="let error of stockValidationErrors">{{ error }}</li>
      </ul>
      <p class="stock-validation-errors__footer">
        A geração de brindes está bloqueada enquanto todos os brindes não
        atenderem ao mínimo de
        <strong>{{ filteredCustomers().length }}</strong> unidades em estoque.
      </p>
    </div>

    <div class="buttons">
      <p-button
        icon="pi pi-send"
        label="Gerar brindes"
        type="button"
        (onClick)="generateGifts($event)"
        [disabled]="!canGenerate"
        [pTooltip]="canGenerateTooltip"
      ></p-button>
    </div>
  </section>
</div>

<p-toast />
<p-confirmPopup />
